function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useValidation from './useValidation';
import TextInput from './text-input';
import CheckUtils from './check-utils';
var SboPackageContents = function SboPackageContents(props) {
  var _useState = useState(new Map()),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOptions = _useState2[0],
    setSelectedOptions = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    otherText = _useState4[0],
    setOtherText = _useState4[1];
  var maxOptionsAllowed = 4;
  var contentTypes = props.contentTypes,
    setSelectedContentTypes = props.setSelectedContentTypes,
    showErrors = props.showErrors,
    handleValidationChange = props.handleValidationChange;
  var validations = {
    selectedOptions: {
      custom: {
        func: function func(val) {
          if (val.size === 0) {
            return {
              message: 'You must select at least one option',
              passed: false
            };
          }
          if (val.has('other') && val.get('other').labelText === '') {
            return {
              message: 'Please specify why you chose Other',
              passed: false
            };
          }
          return true;
        },
        message: ''
      }
    }
  };
  var _useValidation = useValidation(validations),
    _useValidation2 = _slicedToArray(_useValidation, 3),
    validator = _useValidation2[0],
    validationErrors = _useValidation2[1],
    isValid = _useValidation2[2];
  var errorMsgRef = useRef();

  /**
   * scrolls error message into view upon showErrors
   */
  useEffect(function () {
    if (showErrors) {
      if (errorMsgRef.current) {
        errorMsgRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [showErrors]);

  /**
   * sets our validation function to validate any fields we require on change
   */
  useEffect(function () {
    validator({
      selectedOptions: selectedOptions
    });
  }, [selectedOptions]);

  /**
   * set our global validation with our updated one.
   */
  useEffect(function () {
    handleValidationChange({
      key: 'package-contents',
      value: isValid
    });
  }, [isValid]);

  /**
   * update parent with newly selected options.
   */
  useEffect(function () {
    setSelectedContentTypes(selectedOptions);
  }, [selectedOptions]);

  /**
   * handles the selection of checkboxes for content types.
   * @param id
   */
  var handleSelectedOptionsChange = function handleSelectedOptionsChange(id) {
    var newMap = new Map(selectedOptions);
    if (selectedOptions.has(id)) {
      if (id === 'other') {
        setOtherText('');
      }
      newMap.delete(id);
    } else if (newMap.size < maxOptionsAllowed) {
      var clone = _objectSpread({}, contentTypes[id]);
      clone.serialNumbers = [''];
      newMap.set(id, clone);
    }
    setSelectedOptions(newMap);
  };

  /**
   * handles the text input for "Other" content type
   * @param e
   */
  var handleOtherTextInput = function handleOtherTextInput(e) {
    var newMap = new Map(selectedOptions);
    if (e.target.value.length > 18) {
      e.preventDefault();
      return;
    }
    setOtherText(e.target.value);
    newMap.set('other', {
      labelText: e.target.value
    });
    setSelectedOptions(newMap);
    contentTypes.other.labelText = e.target.value;
  };

  /**
   * handles input of serial numbers for options that allow them
   * @param type
   * @param serial
   * @param index
   */
  var handleSerialNumber = function handleSerialNumber(type, serial, index) {
    var newMap = new Map(selectedOptions);
    var option = newMap.get(type);
    option.serialNumbers[index] = serial;
    newMap.set(type, option);
    setSelectedOptions(newMap);
  };

  /**
   * adds a new serial number field for user
   * @param e
   * @param type
   */
  var handleAddSerial = function handleAddSerial(e, type) {
    e.preventDefault();
    var newMap = new Map(selectedOptions);
    var option = newMap.get(type);
    option.serialNumbers.push('');
    newMap.set(type, option);
    setSelectedOptions(newMap);
  };

  /**
   * removes selected serial number from view and selected options
   * @param e
   * @param type
   * @param index
   */
  var handleRemoveSerial = function handleRemoveSerial(e, type, index) {
    e.preventDefault();
    var newMap = new Map(selectedOptions);
    var option = newMap.get(type);
    option.serialNumbers.splice(index, 1);
    if (option.serialNumbers.length === 0) {
      option.serialNumbers.push('');
    }
    newMap.set(type, option);
    setSelectedOptions(newMap);
  };

  /**
   * renders the serial number input fields for each serial number
   * @param type
   * @returns {JSX.Element|null}
   */
  var renderAddSerialNumbers = function renderAddSerialNumbers(type) {
    var option = selectedOptions.get(type);
    if (option) {
      var serialNos = option.serialNumbers.map(function (serial, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "custom-text",
          key: "".concat(type, "-").concat(index)
        }, /*#__PURE__*/React.createElement(TextInput, {
          onValueChange: function onValueChange(e) {
            return handleSerialNumber(type, e.target.value, index);
          },
          name: type,
          inputValue: serial,
          label: "Enter serial number"
        }), /*#__PURE__*/React.createElement("button", {
          className: "btn like-a remove print-shipping-btn-size",
          onClick: function onClick(e) {
            return handleRemoveSerial(e, type, index);
          },
          disabled: CheckUtils.isNullOrEmptyString(option.serialNumbers[index])
        }, "X Remove"));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "serial-numbers"
      }, serialNos, /*#__PURE__*/React.createElement("button", {
        className: "btn like-a add print-shipping-btn-size",
        onClick: function onClick(e) {
          return handleAddSerial(e, type);
        },
        disabled: CheckUtils.isNullOrEmptyString(option.serialNumbers[option.serialNumbers.length - 1])
      }, "+ Add another serial number"));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "section package-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Package contents"), /*#__PURE__*/React.createElement("p", null, "Select all that apply, up to a maximum of four options."), !isValid ? /*#__PURE__*/React.createElement("p", {
    className: "has-error",
    ref: errorMsgRef
  }, validationErrors.selectedOptions) : /*#__PURE__*/React.createElement("p", {
    className: "has-error"
  }, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: "options"
  }, Object.keys(contentTypes).map(function (type) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: type
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner-options"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      onChange: function onChange() {
        return handleSelectedOptionsChange(type);
      },
      id: type,
      checked: selectedOptions.has(type)
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: type,
      className: "options-label"
    }, contentTypes[type].text, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "\xA0")))), contentTypes[type].allowSerialNumbers && selectedOptions.has(type) && renderAddSerialNumbers(type), type === 'other' && selectedOptions.has(type) && /*#__PURE__*/React.createElement("div", {
      className: "custom-text"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onValueChange: function onValueChange(e) {
        return handleOtherTextInput(e);
      },
      name: type,
      inputValue: otherText,
      label: "Other, please specify",
      isRequired: true,
      hasError: CheckUtils.isNullOrEmptyString(otherText)
    })));
  })));
};
export default SboPackageContents;
SboPackageContents.propTypes = {
  contentTypes: PropTypes.objectOf(PropTypes.shape({
    text: PropTypes.string,
    labelText: PropTypes.string,
    allowSerialNumbers: PropTypes.bool
  })).isRequired,
  setSelectedContentTypes: PropTypes.func,
  handleValidationChange: PropTypes.func,
  showErrors: PropTypes.bool
};
SboPackageContents.defaultProps = {
  setSelectedContentTypes: function setSelectedContentTypes() {},
  handleValidationChange: function handleValidationChange() {},
  showErrors: false
};